import { Loader } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { useEffect } from 'react'

import { Head } from '../../../src/component'
import { Route } from '../../../src/config/router'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'
import { useAppRouter } from '../../../src/state'

export const InitiateBankVerificationPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()

  const pageTitle = `${t('processing:pageTitle')} | ${t('common:brandName')}`

  useEffect(() => {
    router.push(Route.EMPLOYMENT_DETAILS)
  }, [])

  return (
    <>
      <Head title={pageTitle} />
      <Loader text={t('consumerLending:preAssessment:loader')} />
      <TrackPageViewed />
    </>
  )
}
